import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import configs from './config'
import Buefy from 'buefy'
import './styles/scss/main.scss'

configs.printModeIsDEV();

Vue.use(Buefy)
Vue.config.productionTip = false



new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
